import { getOrdersId } from "Infrastructure/Api/Api";
import { processResponse } from "Infrastructure/Api/ApiUtils";
import { useQuery } from "@tanstack/react-query";

export const ORDER_DETAIL = "ORDER_DETAIL";

export const getOrderDetailQueryKey = (orderId?: number) => {
	return [ORDER_DETAIL, orderId];
};

export function useOrderDetailQuery(orderId?: number) {
	return useQuery({
		queryKey: getOrderDetailQueryKey(orderId),
		queryFn: processResponse(() => getOrdersId(orderId!)),
		retry: false,
		refetchInterval: false,
		refetchIntervalInBackground: false,
		refetchOnWindowFocus: true,
		enabled: !!orderId,
	});
}
